import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_ASSET_QUERY_KEY = 'assets.getAsset';

const defaultParameters = { enabled: true };

export const useGetAsset = ({
  assetId,
  assetTenantId,
  enabled,
}: { assetId?: string; assetTenantId?: string; refetchInterval?: number; enabled?: boolean } = defaultParameters) => {
  const { getTenantId } = useTenants();
  const tenantId = assetTenantId ?? getTenantId();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [GET_ASSET_QUERY_KEY, { assetId, tenantId }],
    queryFn: () => api.assets.getAsset(tenantId, assetId ?? ''),
    enabled: !!assetId && !!tenantId && enabled,
  });

  return {
    asset: data?.data.asset,
    isLoading,
    error,
    refetch,
  };
};
